import { useEffect } from "react";

const PAGE_TITLE = "Contractor Terms | Accent Productions";

/**
 * Ported from web/src/app/contractor-terms/page.tsx (Next.js App Router).
 *
 * - next/metadata export -> document.title effect (SEO deferred).
 * - Pure content page, no Next-specific APIs.
 */
export default function ContractorTermsPage() {
  useEffect(() => {
    document.title = PAGE_TITLE;
  }, []);

  return (
    <div className="max-w-prose mx-auto px-4 sm:px-6 py-12">
      <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-gray-900 mb-8">Contractor Terms</h1>

      <div className="space-y-10 text-gray-600">
        {/* Engagement & Pay */}
        <div>
          <h2 className="text-lg font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">Engagement & Pay</h2>
          <div className="space-y-6">
            <section>
              <h3 className="text-base font-semibold text-gray-900 mb-1">Status</h3>
              <p>You are engaged as an independent contractor, not an employee. There is no entitlement to leave, benefits, or ongoing work commitment.</p>
            </section>
            <section>
              <h3 className="text-base font-semibold text-gray-900 mb-1">Pay</h3>
              <p>Payment is made within 7 days of event completion via bank transfer, at the rate specified in your job offer.</p>
            </section>
            <section>
              <h3 className="text-base font-semibold text-gray-900 mb-1">Cancellation by Contractor</h3>
              <p>A minimum of 48 hours notice is required if you need to cancel. No-shows without notice may result in removal from future work.</p>
            </section>
            <section>
              <h3 className="text-base font-semibold text-gray-900 mb-1">Cancellation by Accent Productions</h3>
              <p>Accent Productions may withdraw a job offer at any time before the event, including if a response has not been received within a reasonable timeframe. You will be notified by email if a job offer is cancelled. Once cancelled, the accept/decline links in the original offer will no longer work.</p>
            </section>
            <section>
              <h3 className="text-base font-semibold text-gray-900 mb-1">Insurance</h3>
              <p>You are responsible for your own ACC levies and personal liability insurance.</p>
            </section>
          </div>
        </div>

        {/* On-site Responsibilities */}
        <div>
          <h2 className="text-lg font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">On-site Responsibilities</h2>
          <div className="space-y-6">
            <section>
              <h3 className="text-base font-semibold text-gray-900 mb-1">Equipment</h3>
              <p>Exercise reasonable care with all company equipment. Report any damage immediately.</p>
            </section>
            <section>
              <h3 className="text-base font-semibold text-gray-900 mb-1">Conduct</h3>
              <p>Represent Accent Productions professionally at all times. No alcohol or drugs on site.</p>
            </section>
            <section>
              <h3 className="text-base font-semibold text-gray-900 mb-1">Confidentiality</h3>
              <p>Client details, pricing, and business information must not be shared with third parties.</p>
            </section>
          </div>
        </div>

        <p className="text-sm text-gray-400 pt-4">Last updated: April 2026</p>
      </div>
    </div>
  );
}
